<script setup lang="ts">
import { ref } from 'vue'
import BaseButtonPrimary from '../../../base/BaseButtonPrimary.vue'
import { Signature } from '../../../../utilities/account/useAccountDataPersonal'

const loading = ref(false)

function navigateTo(link) {
    window.open(link, '_blank').focus()
}

const props = defineProps<{
    signature: Signature
}>()
</script>

<template>
    <BaseButtonPrimary :disabled="loading" :loading="loading" @click="navigateTo(props.signature.link)">
        <span v-if="signature.signed_at === null">
            {{ $t('signatures.sign_document') }}
        </span>
        <span v-else>
            {{ $t('signatures.show_document') }}
        </span>
    </BaseButtonPrimary>
</template>

<style scoped></style>
